import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

function redirectLocalIpToLocalhost(): boolean {
  if (window.location.hostname !== "127.0.0.1") {
    return false;
  }

  const nextUrl = new URL(window.location.href);
  nextUrl.hostname = "localhost";
  window.location.replace(nextUrl.toString());
  return true;
}

if (!redirectLocalIpToLocalhost()) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
